import { NgModule } from '@angular/core';
import { FolderViewComponent } from './folder-view.component';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { ListViewComponent } from "./list-view/list-view.component";
import { GridViewComponent } from "./grid-view/grid-view.component";
import { TranslocoModule } from '@jsverse/transloco';

@NgModule({
  declarations: [
    FolderViewComponent,
    GridViewComponent,
    ListViewComponent
  ],
  imports: [
    FormsModule,
    CommonModule,
    TranslocoModule
  ],
  exports: [
    FolderViewComponent,
  ]
})
export class FolderViewModule { }
